import FqApi from '@/services/fq-api'

export default {
  async getEntity(id) {
    const url = '/companysettings/getcompanysetting'
    const result = await FqApi.get(url)
    return result.data
  },
  async UpdateFiscalSetting(fiscalStart, fiscalDuration) {
    const url = `/companysettings/updatefiscalsetting?fiscalstart=${fiscalStart}&fiscalduration=${fiscalDuration}`
    return await FqApi.put(url)
  },
  async alterCompanySettings(settingName, enable = true) {
    const url = `/companysettings/alterCompanySettings?name=${settingName}&enable=${enable}`
    const result = await FqApi.post(url)
    return result.data
  },
  async getCompanyDetails(companyId) {
    let url = '/companysettings/getCompanyDetails'
    if (companyId) url = `${url}?companyId=${companyId}`
    const result = await FqApi.get(url)
    return result.data
  },
  async getCompanyLicense(companyId) {
    let url = '/companysettings/getCompanyLicense'
    if (companyId) url = `${url}?companyId=${companyId}`
    const result = await FqApi.get(url)
    return result.data
  },
  async getCompanyModules(companyId) {
    let url = '/companysettings/getCompanyModules'
    if (companyId) url = `${url}?companyId=${companyId}`
    const result = await FqApi.get(url)
    return result.data
  },
  async getCompanyItemCategories(companyId) {
    let url = '/companysettings/getCompanyItemCategories'
    if (companyId) url = `${url}?companyId=${companyId}`
    const result = await FqApi.get(url)
    return result.data
  },
  async getCompanyExternalSettings(companyId) {
    let url = '/companysettings/getCompanyExternalSetting'
    if (companyId) url = `${url}?companyId=${companyId}`
    const result = await FqApi.get(url)
    return result.data
  },
  async getCompanyATGLAccounts() {
    const url = '/companysettings/getCompanyATGLAccounts'
    const result = await FqApi.get(url)
    return result.data
  },
  async updateCompanyDetails(companyDetails, companyId) {
    let url = '/companysettings/updateCompanyDetails'
    if (companyId) url = `${url}?companyId=${companyId}`
    const result = await FqApi.post(url, companyDetails)
    return result.data
  },
  async updateCompanyLicense(companyLicense, companyId) {
    let url = '/companysettings/updateCompanyLicense'
    if (companyId) url = `${url}?companyId=${companyId}`
    const result = await FqApi.post(url, companyLicense)
    return result.data
  },
  async updateCompanyModules(companyModules, companyId) {
    let url = '/companysettings/updateCompanyModules'
    if (companyId) url = `${url}?companyId=${companyId}`
    const result = await FqApi.post(url, companyModules)
    return result.data
  },
  async updateCompanyItemCategories(companyItemCategories, companyId) {
    let url = '/companysettings/updateCompanyItemCategories'
    if (companyId) url = `${url}?companyId=${companyId}`
    const result = await FqApi.post(url, companyItemCategories)
    return result.data
  },
  async updateCompanyExternalSetting(companyExternalSettings) {
    const url = '/companysettings/updateCompanyExternalSetting'
    const result = await FqApi.post(url, companyExternalSettings)
    return result.data
  },
  async updateCompanySetting(companySetting) {
    const url = '/companysettings/updateCompanySetting'
    const result = await FqApi.post(url, companySetting)
    return result.data
  },
  async getCompanyMonthlySettingByFY(fiscalYear) {
    const url = `companymonthlysettings/getcompanymonthlysettingbyfy/${fiscalYear}`
    const result = await FqApi.get(url)
    return result.data
  },
  async getFiscalYearList() {
    const url = 'companymonthlysettings/getfiscalyearlist'
    const result = await FqApi.get(url)
    return result.data
  },
  async getAllFiscalYear() {
    const url = 'companymonthlysettings/getallfiscalyear'
    const result = await FqApi.get(url)
    return result.data
  },
  async postMonthlySettingEntity(entity) {
    const result = await FqApi.post('/companymonthlysettings', entity)
    return result.data
  },
  async putMonthlySettingEntity(entity, fiscalYear) {
    const result = await FqApi.put(`/companymonthlysettings?fiscalyear=${fiscalYear}`, entity)
    return result.data
  },
  async checkExists(year, month) {
    const url = `companymonthlysettings/checkexists/${year}/${month}`
    const result = await FqApi.get(url)
    return result.data
  },
  async getCompanyBatchSetting(systemType) {
    const url = `/companysettings/getCompanyBatchSetting/${systemType}`
    const result = await FqApi.get(url)
    return result.data
  },
  async updateCompanyBatchSetting(companyBatchSetting) {
    const url = '/companysettings/updateCompanyBatchSetting'
    const result = await FqApi.post(url, companyBatchSetting)
    return result.data
  },
  async getCompanyBatchSettings() {
    const url = '/companysettings/getCompanyBatchSettings'
    const result = await FqApi.get(url)
    return result.data
  },
  async getNewCompanyDetails() {
    let url = '/companysettings/getNewCompanyDetails'
    const result = await FqApi.get(url)
    return result.data
  },
  async getNewCompanyLicense() {
    let url = '/companysettings/getNewCompanyLicense'
    const result = await FqApi.get(url)
    return result.data
  },
  async getNewCompanyModules() {
    let url = '/companysettings/getNewCompanyModules'
    const result = await FqApi.get(url)
    return result.data
  },
  async getNewCompanyExternalSettings() {
    let url = '/companysettings/getNewCompanyExternalSettings'
    const result = await FqApi.get(url)
    return result.data
  },
  async getCompanyPermissionRecords(params) {
    let url = `/companysettings/getCompanyPermissionRecords?companyId=${params.companyId}&selectedModuleIds=${params.selectedModuleIds}`
    const result = await FqApi.get(url)
    return result.data
  },
  async postCompany(company) {
    return FqApi.post('/companysettings', company)
  },
  async deleteCompany(companyId) {
    return FqApi.delete(`/companysettings/deleteCompany/${companyId}`)
  },
  async updateCompanyPermissionRecords(companyPermissionRecords, companyId) {
    let url = '/companysettings/updateCompanyPermissionRecords'
    if (companyId) url = `${url}?companyId=${companyId}`
    const result = await FqApi.post(url, companyPermissionRecords)
    return result.data
  },
  async checkCompanyNameValidity(companyId, companyName) {
    const result = await FqApi.post('/companysettings/checkCompanyNameValidity', { companyId, companyName })
    return result.data
  },
  async validateCompanyRegisteredID(companyId, companyRegisteredId) {
    const result = await FqApi.post('/companysettings/validateCompanyRegisteredID', { companyId, companyRegisteredId })
    return result.data
  },
  async getTimeZonesByCountryCode(countryCode) {
    let url = `/companysettings/getTimeZonesByCountryCode?countryCode=${countryCode}`
    const result = await FqApi.get(url)
    return result.data
  }
}
